import { render } from "./UserNavbarInfo.vue?vue&type=template&id=579c3ea4"
import script from "./UserNavbarInfo.vue?vue&type=script&lang=js"
export * from "./UserNavbarInfo.vue?vue&type=script&lang=js"

import "./UserNavbarInfo.vue?vue&type=style&index=0&id=579c3ea4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__